var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"banner-info flex items-center gap-2 cursor-pointer",style:(_vm.borderStyles),on:{"click":function($event){return _vm.$emit('onToggleView')}}},[_c('p',{staticClass:"banner-info__text"},[_c('strong',[_vm._v(_vm._s(_vm.title || 'Tier Header'))])]),_c('button',{attrs:{"isDisabled":_vm.isDisabled}},[_c('img',{staticClass:"arrow",class:{
          active: _vm.isAccordionOpen
        },attrs:{"src":require("@/assets/dropdownarrow.svg")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }